const state = {
  userInfo: {},
  wxConfig: {},
  shareConfig: {},
  follw: false,
  isOpenVipConfig: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js